
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';


import {Provider} from 'react-redux';
import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import createLogger from 'redux-logger';
import allReducers from './dev/reducers';
import Routers from './routes';

import 'bootstrap/dist/css/bootstrap.min.css';

import * as JJ from "jquery";
import 'bootstrap-notify/bootstrap-notify.min.js';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';


window.jQuery = window.$ = JJ
window.notify = window.$.notify


require("bootstrap/dist/js/bootstrap.min.js");
require("bootstrap-datepicker/dist/locales/bootstrap-datepicker.pt-BR.min.js");

//config datepicker
window.jQuery.fn.datepicker.defaults.format = "dd/mm/yyyy";
window.jQuery.fn.datepicker.defaults.autoclose = true;
window.jQuery.fn.datepicker.defaults.todayHighlight = true;
window.jQuery.fn.datepicker.defaults.toggleActive = true;
window.jQuery.fn.datepicker.defaults.language = "pt-BR";

const logger = createLogger();
const store = createStore(
    allReducers,
    applyMiddleware(thunk, promise, logger)
);

ReactDOM.render(
    <Provider store={store}>
        <Routers />
    </Provider>,
    document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


